import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaShieldAlt } from "react-icons/fa";

export default function ConfirmInvestmentModal({
  open,
  onClose,
  onProceed,
  plan,
  loading,
}) {
  const PLAN_NAME_MAP = {
    plan1: "Core Growth",
    plan2: "Institutional Blend",
    plan3: "Founder’s Syndicate",
  };

  const getPlanDisplayName = (planKey) => {
    if (!planKey) return "";
    return PLAN_NAME_MAP[planKey.toLowerCase()] || planKey;
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[999] flex items-center justify-center bg-black/80 backdrop-blur-md p-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onMouseDown={(e) => {
            if (e.target === e.currentTarget) onClose();
          }}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.92, y: 30 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.92, y: 30 }}
            transition={{ duration: 0.25 }}
            className="relative w-full max-w-md overflow-hidden rounded-[32px] border border-yellow-500/20 bg-[#07111f] shadow-[0_25px_80px_rgba(234,179,8,0.15)]"
          >
            {/* Background Glow */}
            <div className="absolute -top-28 left-1/2 h-56 w-56 -translate-x-1/2 rounded-full bg-yellow-500/10 blur-3xl" />

            <div className="relative p-7">
              {/* Icon */}
              <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full border border-yellow-500/20 bg-gradient-to-br from-yellow-400/20 to-yellow-600/10">
                <FaShieldAlt className="text-2xl text-yellow-400" />
              </div>

              {/* Title */}
              <h3 className="text-center text-2xl font-black text-white">
                Confirm Investment
              </h3>

              <p className="mt-2 text-center text-sm leading-6 text-slate-400">
                Please review your investment details before generating the
                payment invoice.
              </p>

              {/* Plan Card */}
              <div className="mt-7 rounded-3xl border border-yellow-500/20 bg-gradient-to-br from-yellow-500/10 via-[#0d1b2a] to-[#07111f] p-6">

                <div className="text-xs font-bold uppercase tracking-[3px] text-yellow-400">
                  {getPlanDisplayName(plan?.name)}
                </div>

                <div className="mt-3 text-4xl font-black text-white">
                  ${plan?.amount +8 }
                </div>

                <div className="mt-5 grid grid-cols-2 gap-4 border-t border-yellow-500/10 pt-5">

                  <div>
                    <p className="text-[11px] uppercase tracking-wider text-slate-500">
                      Asset
                    </p>

                    <p className="mt-1 font-bold text-white">
                      USDT
                    </p>
                  </div>

                  <div className="text-right">
                    <p className="text-[11px] uppercase tracking-wider text-slate-500">
                      Network
                    </p>

                    <p className="mt-1 font-bold text-yellow-400">
                      ERC20
                    </p>
                  </div>

                </div>
              </div>

              {/* Info Box */}
              <div className="mt-5 rounded-2xl border border-slate-800 bg-slate-900/40 p-4">
                <p className="text-xs leading-6 text-slate-400">
                  After clicking{" "}
                  <span className="font-bold text-yellow-400">
                    Proceed
                  </span>
                  , a secure payment invoice will be generated. Complete the
                  payment to activate your investment plan.
                </p>
              </div>

              {/* Buttons */}
              <div className="mt-7 flex gap-4">

                <button
                  onClick={onClose}
                  disabled={loading}
                  className="flex-1 rounded-2xl border border-slate-700 bg-slate-900 py-4 font-bold text-slate-300 transition-all duration-300 hover:border-yellow-500/40 hover:text-yellow-400 disabled:opacity-50"
                >
                  Cancel
                </button>

                <button
                  onClick={onProceed}
                  disabled={loading}
                  className="flex-1 rounded-2xl bg-gradient-to-r from-yellow-400 via-amber-500 to-yellow-500 py-4 font-black text-slate-900 shadow-lg shadow-yellow-500/30 transition-all duration-300 hover:scale-[1.03] hover:shadow-yellow-500/40 active:scale-95 disabled:cursor-not-allowed disabled:opacity-50"
                >
                  {loading ? "Generating..." : "Proceed"}
                </button>

              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}